import { Container } from '../components/Layout.tsx';
import { LinkButton, PageTitle } from '../components/ui.tsx';
import { useTitle } from '../hooks.ts';

export function NotFoundPage() {
  useTitle('Sidan finns inte');
  return (
    <Container narrow>
      <PageTitle sub="Adressen kan vara felstavad eller så har sidan flyttats.">Sidan finns inte</PageTitle>
      <LinkButton to="/">Till startsidan</LinkButton>
    </Container>
  );
}
